import {Component, OnDestroy, OnInit, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import { SavedCartListComponent } from '@spartacus/cart/saved-cart/components';
import { SavedCartFacade } from '@spartacus/cart/saved-cart/root';
import { RoutingService, TranslationService, User } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UigCartService } from '../../uig-cart.service';
import {Cart} from "@spartacus/cart/base/root";
import {LaunchDialogService} from "@spartacus/storefront";

@Component({
    selector: 'app-uig-saved-cart-list',
    templateUrl: './uig-saved-cart-list.component.html',
    styleUrls: ['./uig-saved-cart-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigSavedCartListComponent extends SavedCartListComponent implements OnInit, OnDestroy {
  private savedCartSubscription = new Subscription();
  readonly datePattern = 'dd.MM.yyyy';
  isRestricted: boolean = false;
  RIO_CART_ORDER: string = "rio_cart_order";
  RIO_CART_CREATE_UPDATE: string = "rio_cart_create_update";
  private userSubscription = new Subscription();

  isLoading$: Observable<boolean> = this.savedCartService.getSavedCartListProcessLoading();
  savedCartsList$: Observable<Cart[]> = this.uigCartService.getList().pipe(
    map((lists) =>
      lists.sort((a: Cart, b: Cart) => {
        let date1: number = a.saveTime
          ? new Date(a.saveTime).getTime()
          : new Date().getTime();
        let date2: number = b.saveTime
          ? new Date(b.saveTime).getTime()
          : new Date().getTime();
        return date2 - date1;
      })
    )
  );

  constructor(
    protected routing: RoutingService,
    protected translation: TranslationService,
    protected savedCartService: SavedCartFacade,
    protected uigCartService: UigCartService,
    private userAccountFacade: UserAccountFacade,
    protected vcr: ViewContainerRef,
    protected launchDialogService: LaunchDialogService
  ) {
    super(routing, savedCartService, vcr, launchDialogService);
  }

  ngOnInit(): void {
    this.isLoading$ = this.savedCartService.getSavedCartListProcessLoading();
    this.savedCartService.loadSavedCarts();
    this.checkForRoles();
  }

  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && (user.roles.includes(this.RIO_CART_CREATE_UPDATE)
            || user.roles.includes(this.RIO_CART_ORDER));
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }

  restoreSavedCart(event: Event, cartId: string): void {
    this.savedCartService.restoreSavedCart(cartId);
    event.stopPropagation();
  }

  ngOnDestroy(): void {
    this.savedCartService.clearSavedCarts();
    this.savedCartService.clearSaveCart();
    this.savedCartService.clearRestoreSavedCart();
    this.savedCartSubscription?.unsubscribe();
    this.userSubscription?.unsubscribe();
  }

}
